export default function Podcast({
  podcastId,
  light = false,
  onLoad,
}: {
  podcastId: string;
  light?: boolean;
  onLoad?: () => void;
}) {
  return (
    <iframe
      title="Podcast iframe"
      src={`https://playlist.megaphone.fm/?p=${podcastId}&artwork=false&sharing=false&light=${light}`}
      width="100%"
      height="482"
      onLoad={onLoad}
    ></iframe>
  );
}
